/**
 * Korean editor names — `import '@iyulab/u-widgets/tools/locales/ko'` registers them as `ko`, so
 * `getWidgetOptions`, `getWidgetDataFields` and `getWidgetLabel` name things in Korean wherever the
 * locale is `ko` or `ko-KR`. Every widget, option and data field has a name here; a test fails when
 * one added to the catalog has none.
 */
import { registerToolLabels, type ToolLabels } from '../core/tool-labels.js';

export const toolLabelsKo: ToolLabels = {
  widgets: {
    'chart.bar': '막대 차트',
    'chart.line': '선 차트',
    'chart.area': '영역 차트',
    'chart.pie': '원형 차트',
    'chart.scatter': '산점도',
    'chart.radar': '방사형 차트',
    'chart.heatmap': '히트맵',
    'chart.box': '상자 그림',
    'chart.funnel': '깔때기 차트',
    'chart.waterfall': '폭포 차트',
    'chart.treemap': '트리맵',
    'chart.histogram': '히스토그램',
    'chart.gantt': '간트 차트',
    'metric': '지표',
    'stat-group': '지표 묶음',
    'gauge': '게이지',
    'progress': '진행 막대',
    'table': '표',
    'list': '목록',
    'form': '입력 양식',
    'confirm': '확인',
    'markdown': '마크다운',
    'image': '이미지',
    'callout': '알림 상자',
    'code': '코드 블록',
    'citation': '인용',
    'status': '상태',
    'steps': '단계',
    'rating': '평점',
    'video': '동영상',
    'gallery': '갤러리',
    'kv': '키-값 목록',
    'math': '수식',
    'actions': '동작 버튼',
    'divider': '구분선',
    'header': '제목',
    'compose': '구성',
  },
  options: {
    min: '최솟값',
    max: '최댓값',
    unit: '단위',
    thresholds: '임계 구간',
    label: '라벨',
    smooth: '부드러운 곡선',
    stack: '누적',
    horizontal: '가로 방향',
    donut: '도넛',
    colors: '색상',
    colorRange: '색 범위',
    histogram: '히스토그램',
    bins: '구간 수',
    referenceLines: '기준선',
    categories: '행 순서',
    series: '계열',
    conditionalStyles: '조건부 스타일',
    subtitle: '부제',
    format: '값 서식',
    step: '계단선',
    legend: '범례',
    grid: '격자선',
    animate: '애니메이션',
    showLabel: '값 표시',
    xFormat: 'X축 서식',
    yFormat: 'Y축 서식',
    valueAxisZero: '값 축을 0부터',
    xAxisType: 'X축 종류',
    pageSize: '페이지당 행 수',
    compact: '간결하게',
    searchable: '검색 상자',
    locale: '로케일',
    lineNumbers: '줄 번호',
    highlight: '강조할 줄',
    maxHeight: '최대 높이',
    wrap: '줄 바꿈',
    numbered: '번호 표시',
    interactive: '직접 입력',
    icon: '아이콘',
    autoplay: '자동 재생',
    controls: '재생 컨트롤',
    loop: '반복 재생',
    muted: '음소거',
    aspectRatio: '가로세로 비율',
    displayMode: '표시 방식',
    layout: '배치',
    columns: '열 수',
    widths: '열 너비',
    spacing: '간격',
    card: '카드',
  },
  dataFields: {
    value: '값',
    label: '라벨',
    unit: '단위',
    prefix: '앞 글자',
    suffix: '뒤 글자',
    change: '변화량',
    trend: '추세',
    icon: '아이콘',
    description: '설명',
    max: '최댓값',
    content: '내용',
    src: '원본 주소',
    alt: '대체 텍스트',
    caption: '캡션',
    message: '메시지',
    title: '제목',
    level: '수준',
    language: '언어',
    expression: '수식',
    text: '텍스트',
    poster: '포스터 이미지',
    tracks: '자막 트랙',
    status: '상태',
    count: '개수',
    url: '링크',
    snippet: '발췌',
    source: '출처',
  },
  widgetOptions: {
    rating: { max: '아이콘 수' },
    divider: { label: '텍스트' },
  },
  widgetDataFields: {
    header: { level: '제목 수준' },
  },
};

registerToolLabels('ko', toolLabelsKo);
